import { useEffect } from "react";
import { useMeQuery, useQuoteUpdatedSubscription } from "generated/graphql";

type Reexecute = (opts?: { requestPolicy?: "network-only" }) => void;

/**
 * Refetches a quote list when an existing quote changes hands — the vendor
 * revises it, or the customer approves it / asks for changes — so the other
 * side sees the new state without revisiting the page.
 *
 * Paused while logged out for the same reason as useQuoteCreated: an
 * unauthenticated socket is rejected (close 4403) and graphql-ws keeps retrying.
 */
export const useQuoteUpdated = (reexecute: Reexecute) => {
  const [{ data: me }] = useMeQuery();
  const [{ data: event }] = useQuoteUpdatedSubscription({ pause: !me?.me });

  useEffect(() => {
    if (event?.quoteUpdated) {
      reexecute({ requestPolicy: "network-only" });
    }
  }, [event, reexecute]);
};
